import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IDetail {
    id?: string
    title?: string
    startTime?: string
    location?: string
    presenter?: string
    content?: string
    meetingMode?: string
    meetingType?: string
    createUser?: string
    checkinCode?: string
    qrcodePath?: string
    status?: string | number
    createTime?: string
    onlineMeetingDetailsList?: any[]
    driverInformationList?: any[]
    meetingCheckinList?: any[]
    meetingsImgList?: any[]

    [key: string]: any
}

//新增
export interface IInsert {
    id?: string
    title?: string
    startTime?: string
    location?: string
    presenter?: string
    content?: string
    meetingType?: string
    meetingMode?: string
    createUser?: string
    checkinCode?: string
    qrcodePath?: string
    onlineMeetingDetailsList?: any[]
    meetingsUserList?: any[]
}

//编辑
export interface IUpdate extends IInsert {
    id?: string
    status?: number
}

//搜索条件
export interface ISearchFields {
    content?: string
    startTime?: string
    endTime?: string
    meetingType?: string

    [key: string]: any
}

export interface ISearch extends ISearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

class service {
    async page(searchVo: ISearch, config: object = {}) {
        const apiUrl = '/threeInspection/meetings/list'
        return await httpRequest.post<IPage<IDetail>>(apiUrl, searchVo, config)
    }

    async insert(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/meetings/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }

    async edit(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/meetings/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }

    async onDelete(searchVo: ISearchFields) {
        const apiUrl = '/threeInspection/meetings/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }

    async one(id: string) {
        const apiUrl = '/threeInspection/meetings/one/' + id
        return await httpRequest.get<any>(apiUrl)
    }

    async publish(updateVo: IUpdate) {
        const apiUrl = '/threeInspection/meetings/publish'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }

    async driverList(searchVo: ISearch, config: object = {}) {
        const apiUrl = '/threeInspection/base/driver/list'
        return await httpRequest.post<IPage<IDetail>>(apiUrl, searchVo, config)
    }

    async downloadQrcode(id: string) {
        const apiUrl = '/threeInspection/meetings/qrcode/' + id
        return await httpRequest.getFile<any>(apiUrl)
    }

    async completeMeetings(data: any) {
        const apiUrl = '/threeInspection/meetings/complete'
        return await httpRequest.post<any>(apiUrl, data)
    }
    async exportPDF(id: string) {
        const apiUrl = '/threeInspection/meetings/export/' + id
        return await httpRequest.getFile(apiUrl)
    }
}

export const Service = new service()
